import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-anchor-right-icon',
  templateUrl: './design-anchor-right.component.html'
})
export class DesignAnchorRightComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
